
import { atom } from 'recoil';

export const rodinInitWeightAtom = atom({
  key: 'rodinInitWeightAtom',
  default: 1,
});

export const rodinModalLoadingAtom = atom({
  key: 'rodinModalLoadingAtom',
  default: false
})


export const rodinGenPipeline = atom({
  key: 'rodinGenPipeline',
  default: {
    taskInfo: {
      status: false,
      data: null, // UUID
      restore: {
        status: false,
        data: null,
      },
      timestamp: null
    },
    hold: {
      status: false,
      data: null,
      timestamp: null
    },
    geoPreviewLoading: {
      status: false,
      data: null,
      timestamp: null
    },
    geoPreviewLoaded: {
      status: false,
      data: null,
      timestamp: null
    },
    geoConfirmed: {
      status: false,
      data: null,
      timestamp: null
    },
    geoLoading: {
      status: false,
      data: null,
      timestamp: null
    },
    mtlLoading: {
      status: false,
      data: null,
      timestamp: null
    },
    mtlLoaded: {
      status: false,
      data: null,
      timestamp: null
    },
    mtlConfirmed: {
      status: false,
      data: null,
      timestamp: null
    },
    Packing: {
      status: false,
      data: null,
      timestamp: null
    },
    Done: {
      status: false,
      data: null,
      timestamp: null
    }
  },
});

export const rodinHistoryStatus = atom({
  key: 'rodinHistoryStatus',
  default: {
    showHistoryList: false,
    historyList: [],
    selectedHistory: false,
    refImage: false,
    previewHistory: false,
    originalState: false,
  }
});

export const optionOpenAtom = atom({
  key: 'optionOpenAtom',
  default: false
})

export const optionModeCloseAtom = atom({
  key: 'optionModeCloseAtom',
  default: false
})

export const optionModeRestAtom = atom({
  key: 'optionModeRestAtom',
  default: false
})

export const optionSharpAtom = atom({
  key: 'optionSharpAtom',
  default: false
})

export const renderPreviewImgAtom = atom({
  key: 'renderPreviewImgAtom',
  default: false
})

export const isRodinGeneratingAtom = atom({
  key: 'isRodinGeneratingAtom',
  default: false
})

export const controllerInfoAtom = atom({
  key: 'controllerInfoAtom',
  default: {}
})

export const textureCacheAtom = atom({
  key: 'textureCacheAtom',
  default: {}
})

export const storyListAtom = atom({
  key: 'storyListAtom',
  default: []
})


export const storyTagsAtom = atom({
  key: 'storyTagsAtom',
  default: new Set()
})

export const faceCheckListAtom = atom({
  key: 'faceCheckListAtom',
  default: []
})

export const defaultFaceEnhanceAtom = atom({
  key: 'defaultFaceEnhanceAtom',
  default: []
})

export const allowFaceEnhanceAtom = atom({
  key: 'allowFaceEnhanceAtom',
  default: []
})

export const omniInitAtom = atom({
  key: 'omniInitAtom',
  default: false
})

export const omniPreAtom = atom({
  key: 'omniPreAtom',
  default: false
})

export const imageWorkflowsAtom = atom({
  key: 'imageWorkflowsAtom',
  default: []
})

export const selectedImageIndexAtom = atom({
  key: 'selectedImageIndexAtom',
  default: 0
})

export const checkImgConfirmAtom = atom({
  key: 'checkImgConfirmAtom',
  default: false
})

export const checkDownloadAtom = atom({
  key: 'checkDownloadAtom',
  default: false
})

export const meshEditorMicroAppAtom = atom({
  key: 'meshEditorMicroAppAtom',
  default: {}
})

export const personalStoriesAtom = atom({
  key: 'personalStoriesAtom',
  default: []
})

export const animationStatesAtom = atom({
  key: 'animationStatesAtom',
  default: {}
})

// Data structure for dependencies
export const animationDependenciesAtom = atom({
  key: 'animationDependenciesAtom',
  default: {
    // Example structure
    // welcomePopup: {
    //   next: [
    //     { id: 'featureTour', trigger: 'manual' },
    //     { id: 'tipsAnimation', trigger: 'manual' }
    //   ]
    // },
    // featureTour: {
    //   next: [{ id: 'finalAnimation', trigger: 'auto' }],
    //   dependencies: ['welcomePopup']
    // }
  }
})

export const isAnnotatorOpenAtom = atom({
  key: 'isAnnotatorOpenAtom',
  default: {
    status: false,
    name: '',
    isCrop: false
  }
})

export const isFirstScreenShowAtom = atom({
  key: 'isFirstScreenShowAtom',
  default: true
})

export const likedStoryIdsAtom = atom({
  key: 'likedStoryIdsAtom',
  default: []
})

export const storiesLoadedAtom = atom({
  key: 'storiesLoadedState',
  default: false
});

export const storyListVisibleAtom = atom({
  key: 'storyListVisibleAtom',
  default: []
});

export const storyHomePageJumpAtom = atom({
  key: 'storyHomePageJumpAtom',
  default: false
});

export const promotionsAtom = atom({
  key: 'promotionsAtom',
  default: {
    blackFriday: {
      active: false,
      show: false,
    },
    christmas: {
      active: false,
      show: false,
    },
    newUser: {
      active: true,
      show: false,
    }
  }
})

export const storyImagesMapAtom = atom({
  key: 'storyImagesMapAtom',
  default: {
    firstRender: true,
    imagesMap: {}
  }
})

export const newUserPromotionTimeLeftAtom = atom({
  key: 'newUserPromotionTimeLeftAtom',
  default: {
    'default': {
      hours: 24,
      minutes: 0,
      seconds: 0
    }
  }
})

export const upgradeModalAtom = atom({
  key: 'upgradeModal',
  default: {
    visible: false,
    info: null
  }
});
